import { UI } from "../config/site";

export const getToolbarOffset = () =>
  typeof window !== "undefined" && window.innerWidth >= 900
    ? UI.toolbar.md
    : UI.toolbar.xs;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const y =
    el.getBoundingClientRect().top + window.scrollY - getToolbarOffset();
  window.scrollTo({ top: y, behavior: "smooth" });
};
